const ALLOWED_TRIAL_HOSTS = new Set([
  'project-trial.larksuite.com',
  'project-trial.feishu.cn',
  'project-trial.feishu-boe.cn',
]);

export const isTrialDemoEnvironment = (): boolean => ALLOWED_TRIAL_HOSTS.has(window.location.hostname);

/** 将 trial 域名转换为对应的 API 域名，如 project-trial.feishu.cn -> project.feishu.cn */
export const getAPIHost = (host: string): string | undefined => {
  if (ALLOWED_TRIAL_HOSTS.has(host)) {
    return host.replace('project-trial.', 'project.');
  }
  return undefined;
};

export const TRIAL_DEMO_ABILITIES = {
  // 工作台
  WORKBENCH: false,
  // 团队
  TEAM: false,
  // 切换空间
  SWITCH_SPACE: false,
  // 分享
  SHARE: false,
  // 复制链接
  COPY_LINK: false,
  // 群聊：建群/加群/群空间
  CHAT_GROUP: false,
  // 新建空间
  CREATE_NEW_PROJECT: false,
  // 综搜
  GLOBAL_SEARCH: false,
  // 个人中心
  USER: false,
  // 帮助中心
  HELPCENTER: false,
  // 空间设置
  SETTING: false,
  // 全景视图
  MULTI_PROJECT_VIEW: false,
  // 度量图表
  CHART: true,
  // 创建图表
  CREATE_CHART: false,
  // 催一催
  URGE: false,
  // 复制并同步
  SYNCHRONOUS_CREATION: false,
  // 复制ID
  COPY_ID: false,
  // 工作项 - 我收藏的
  WORKITEM_FAVORITE_TAB: false,
  // 导出
  EXPORT_CSV: false,
  // 工作项 - 路由按钮
  WORK_ITEM_ROUTER_BUTTONS: true,
  // 工作项 - Collect PIN
  WORK_ITEM_COLLECT_PIN: true,
  // 工作项 - BriefOperation
  WORK_ITEM_BRIEF_OPERATION: true,
  // 工作项 - 节点卡片
  WORK_ITEM_NODE_CARD: true,
  // 评论 at人
  COMMENT_MENTION: true,
  // 工作项 - 完成后再评论
  COMMENT_WHEN_FINISHED: true,
  // 链接预览 - 富文本场景
  LINK_PREVIEW: false,
  // 导航栏 - 位置记忆
  TAB_LOCATION_MEMORY: false,
  // 视图默认模式固定为全部
  VIEW_DEFAULT_MODE_FIXED_ALL: true,
  // 一级导航
  MAIN_NAVIGATOR: false,
  // 移动版二维码入口
  MOBILE_QRCODE_ENTRY: false,
  // 自助升级 Banner
  UPGRADE_PLAN_BANNER: false,
  // 二级导航 - 导航配置
  SPACE_NAVIGATION_CONFIG: false,
  // 协作者列表 - 显示部门信息
  COLLABORATOR_ITEM_SUBTITLE: false,
  // 视图指标卡
  VIEW_STATISTIC_WIDGET: false,
  // 体验空间 postMessage 逻辑
  TRAIL_POST_MESSAGE_RECEIVER: true,
  // 功能上新引导
  GUIDE: false,
  // 富文本编辑器图片上传能力
  EDITOR_IMAGE_UPLOAD: false,
  // 体验空间跳过资产登录
  TRIAL_SKIP_LOGIN_ASSET: true,
  // 体验空间登录失败
  TRIAL_LOGIN_FAILED: true,
  // 附件
  ATTACHMENT: false,
};
